<template>
  <div class="see-cell">
    <div class="see-cell-header">
      <div style="padding-bottom: 10px;">
        <span class="see-cell-title">{{ $t('performance.performancequery.supOfficeNo') }}</span>
        <span class="see-cell-value">{{ data.supOfficeName }}</span>
      </div>
      <div style="padding-bottom: 10px;">
        <span class="see-cell-title">{{ $t('performance.performancequery.systemScore') }}</span>
        <span class="see-cell-value">{{ data.totalScore }}</span>
        <span class="see-cell-title" style="padding-left: 25px;">{{ $t('performance.performancequery.performanceScore') }}</span>
        <span class="see-cell-value">{{ data.adjustmentScore }}</span>
      </div>
    </div>
    <div class="see-cell-box">
      <div class="see-cell-item is-left">
        <div class="see-cell-item-header">
          <div class="see-cell-item-title">{{ $t('performance.performancequery.determionationScore') }}</div>
          <div class="see-cell-item-total">{{ $t('performance.performancequery.totalRate') }} <span class="rate">{{ data.qualitativeScore }}</span></div>
        </div>
        <table class="see-cell-table">
          <tr
            v-for="(item, index) in srmQualitativeScoreBodyList"
            :key="index"
          ><td class="left-td">{{ item.qualitativeItemName }}</td><td class="right-td">{{ item.itemScore }}</td></tr>
        </table>
      </div>
      <div class="see-cell-item is-right">
        <div class="see-cell-item-header">
          <div class="see-cell-item-title">{{ $t('performance.performancequery.quantitativeScore') }}</div>
          <div class="see-cell-item-total">{{ $t('performance.performancequery.totalRate') }} <span class="rate">{{ data.rationScore }}</span></div>
        </div>
        <table class="see-cell-table">
          <tr><td class="left-td">{{ $t('performance.performancequery.qualifiedBatchScore') }}</td><td class="right-td">{{ srmRationScore.qualifiedBatchScore }}</td></tr>
          <tr><td class="left-td">{{ $t('performance.performancequery.qualifiedReceiptScore') }}</td><td class="right-td">{{ srmRationScore.qualifiedReceiptScore }}</td></tr>
          <tr><td class="left-td">{{ $t('performance.performancequery.expectedDeliveryScore') }}</td><td class="right-td">{{ srmRationScore.expectedDeliveryScore }}</td></tr>
          <tr><td class="left-td">{{ $t('performance.performancequery.committedDeliveryScore') }}</td><td class="right-td">{{ srmRationScore.committedDeliveryScore }}</td></tr>
          <tr><td class="left-td">{{ $t('performance.performancequery.priceDifferenceScore') }}</td><td class="right-td">{{ srmRationScore.priceDifferenceScore }}</td></tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@plugin/axios'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      srmRationScore: {},
      srmQualitativeScoreBodyList: []
    }
  },
  async created() {
    const data = this.data
    const info = await http({
      url: '/srmPerformanceScore/getSrmPerformanceScoreViewRatings',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {
        id: data.id,
        purOfficeNo: data.purOfficeNo,
        supOfficeNo: data.supOfficeNo,
        ettleOfficeNo: data.settleOfficeNo,
        performanceDate: data.performanceDate
      }
    })
    this.srmQualitativeScoreBodyList = info.srmQualitativeScoreBodyList || []
    this.srmRationScore = info.srmRationScore || {}
  }
}
</script>

<style lang="scss" scoped>
.see-cell {
  &-header {
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-title, &-value {
    font-size: 13px;
    line-height: 24px;
  }
  &-value {
    padding-left: 10px;
    font-weight: 600;
    color: #666;
  }
  &-box {
    display: flex;
    align-items: stretch;
    font-size: 12px;
  }
  &-item {
    padding: 10px 0;
    width: 50%;
    .rate {
      font-weight: 600;
    }
    &.is-left {
      padding-right: 15px;
      .rate {
        color: rgba(0, 142, 227, 1);
      }
    }
    &.is-right {
      padding-left: 15px;
      .see-cell-item-title::before {
        background: rgb(145, 211, 87);
      }
      .rate {
        color: rgb(145, 211, 87);
      }
    }
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
    }
    &-title::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 10px;
      background: rgba(0, 142, 227, 1);
      border-radius: 2px;
      margin-right: 5px;
    }
  }
  &-table {
    width: 100%;
    border-collapse: collapse;
    td {
      border: 1px solid #E1E1E1;
      padding: 10px 15px;
      color: #666;
      &.right-td {
        text-align: right;
        color: #333;
        font-weight: 600;
      }
    }
  }
}
</style>
